module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7316/images/default-avatar.png"